// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-page {
    width: 100%;
    margin: 0 auto;
    max-width: 1000px; /* Adjust the max-width for mobile compatibility */
}

.profile-page .banner {
    width: 100%;
    margin: 0;
}

.profile-page .basic-content,
.profile-page .mylocation,
.profile-page .my-issues {
    margin-top: 44px;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
    margin-bottom: 40px;
    width: 100%;
    padding: 0 20px;
}

.profile-page .basic-content h2,
.profile-page .mylocation h2,
.profile-page .my-issues h2 {
    color: #524643;
    font-size: 24px;
    font-weight: 700;
}

.profile-page .form {
    display: flex;
    flex-direction: column;
}

.profile-page .form label {
    margin-top: 20px;
    color: #000;
    font-size: 16px;
    font-weight: 400;
}

.profile-page .form input,
.profile-page .form select,
.profile-page .form datalist {
    font-size: 16px;
    margin-top: 10px;
    width: 100%;
    height: 40px;
    border-radius: 7px;
    border: 2px solid #E5E5E5;
    padding: 10px;
    box-sizing: border-box;
}

.profile-page .line {
    border-bottom: 1px solid #ccc;
    width: 100%;
    height: 1px;
    margin: 20px 0;
}

.profile-page .primary-button,
.profile-page .secondary-button {
    margin: 10px 5px;
    padding: 10px 20px;
    font-size: 16px;
    border: none;
    cursor: pointer;
}

.profile-page .primary-button {
    background-color: #448aea;
    color: white;
}

.profile-page .secondary-button {
    background-color: #ccc;
    color: black;
}

.profile-page .mylocation p,
.profile-page .my-issues p {
    margin-top: 20px;
    color: var(--Border-primary, #000);
    font-size: 16px;
    line-height: 1.5;
}

.profile-page .ranked-issues-container {
    display: flex;
    flex-direction: column;
}

.profile-page .button {
    all: unset;
    align-items: center;
    border-radius: 6.3px;
    display: inline-flex;
    gap: 8.4px;
    justify-content: center;
    padding: 12.6px 21px;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.2s;
    width: 100%;
    max-width: 120px;
    margin: 20px auto;
}

.profile-page .button .text-wrapper {
    color: var(--neutral-0);
    font-family: "Inter-Bold", Helvetica;
    font-size: 16.8px;
    font-weight: 700;
}

.profile-page .button.secondary {
    background-color: var(--primitive-red);
}

.profile-page .button.primary {
    background-color: var(--primitive-blue);
}

.profile-page .button:active {
    transform: scale(0.95);
}

.profile-page .button:hover {
    background-color: gray;
}

.profile-page .logout-container, .profile-page .button-container {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 0 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profile/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB,EAAE,kDAAkD;AACzE;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;;;IAGI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;;;IAGI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;;;IAGI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,WAAW;IACX,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;;IAEI,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,UAAU;IACV,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;IACf,iDAAiD;IACjD,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;IACpC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,eAAe;AACnB","sourcesContent":[".profile-page {\n    width: 100%;\n    margin: 0 auto;\n    max-width: 1000px; /* Adjust the max-width for mobile compatibility */\n}\n\n.profile-page .banner {\n    width: 100%;\n    margin: 0;\n}\n\n.profile-page .basic-content,\n.profile-page .mylocation,\n.profile-page .my-issues {\n    margin-top: 44px;\n    margin-left: auto;\n    margin-right: auto;\n    box-sizing: border-box;\n    margin-bottom: 40px;\n    width: 100%;\n    padding: 0 20px;\n}\n\n.profile-page .basic-content h2,\n.profile-page .mylocation h2,\n.profile-page .my-issues h2 {\n    color: #524643;\n    font-size: 24px;\n    font-weight: 700;\n}\n\n.profile-page .form {\n    display: flex;\n    flex-direction: column;\n}\n\n.profile-page .form label {\n    margin-top: 20px;\n    color: #000;\n    font-size: 16px;\n    font-weight: 400;\n}\n\n.profile-page .form input,\n.profile-page .form select,\n.profile-page .form datalist {\n    font-size: 16px;\n    margin-top: 10px;\n    width: 100%;\n    height: 40px;\n    border-radius: 7px;\n    border: 2px solid #E5E5E5;\n    padding: 10px;\n    box-sizing: border-box;\n}\n\n.profile-page .line {\n    border-bottom: 1px solid #ccc;\n    width: 100%;\n    height: 1px;\n    margin: 20px 0;\n}\n\n.profile-page .primary-button,\n.profile-page .secondary-button {\n    margin: 10px 5px;\n    padding: 10px 20px;\n    font-size: 16px;\n    border: none;\n    cursor: pointer;\n}\n\n.profile-page .primary-button {\n    background-color: #448aea;\n    color: white;\n}\n\n.profile-page .secondary-button {\n    background-color: #ccc;\n    color: black;\n}\n\n.profile-page .mylocation p,\n.profile-page .my-issues p {\n    margin-top: 20px;\n    color: var(--Border-primary, #000);\n    font-size: 16px;\n    line-height: 1.5;\n}\n\n.profile-page .ranked-issues-container {\n    display: flex;\n    flex-direction: column;\n}\n\n.profile-page .button {\n    all: unset;\n    align-items: center;\n    border-radius: 6.3px;\n    display: inline-flex;\n    gap: 8.4px;\n    justify-content: center;\n    padding: 12.6px 21px;\n    cursor: pointer;\n    transition: background-color 0.3s, transform 0.2s;\n    width: 100%;\n    max-width: 120px;\n    margin: 20px auto;\n}\n\n.profile-page .button .text-wrapper {\n    color: var(--neutral-0);\n    font-family: \"Inter-Bold\", Helvetica;\n    font-size: 16.8px;\n    font-weight: 700;\n}\n\n.profile-page .button.secondary {\n    background-color: var(--primitive-red);\n}\n\n.profile-page .button.primary {\n    background-color: var(--primitive-blue);\n}\n\n.profile-page .button:active {\n    transform: scale(0.95);\n}\n\n.profile-page .button:hover {\n    background-color: gray;\n}\n\n.profile-page .logout-container, .profile-page .button-container {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    padding: 0 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
